module.exports = __webpack_public_path__ + "static/media/Ellipse-5.1ee1fac3.svg";